<template>
  <div class="gas-page">
    <div v-if="breadcrumb && breadcrumb.length" class="gas-breadcrumb">
      <span v-for="(item, idx) in breadcrumb" :key="idx">
        <span :class="{ active: idx === breadcrumb.length - 1 }">{{ item }}</span>
        <span v-if="idx < breadcrumb.length - 1" class="sep">&gt;</span>
      </span>
    </div>
    <div class="gas-page-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GasPageShell',
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.gas-page {
  min-height: 100%;
}
.gas-breadcrumb {
  margin-bottom: 16px;
  color: #86909c;
  font-size: 14px;
}
.gas-breadcrumb .sep {
  margin: 0 8px;
  color: #c9cdd4;
}
.gas-breadcrumb .active {
  color: #1d2129;
  font-weight: 500;
}
.gas-page-body {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
</style>
